import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Select from 'react-select';
import { Button, Col, Label, Modal, ModalBody, ModalHeader, Row, Spinner } from 'reactstrap';

import { ASSIGN_VENDOR, ASSIGN_VENDOR_EMPTY, GET_REASON_BY_ACTIONS } from '../../../../../../../store/actions';
import { Error } from '../../../../../../Common';
import AvailabilityTick from './../../../../../../../assets/custom/available-tick.png';
import SelectedItem from './../../../../../../../assets/custom/selected-item.png';

const AssignVendor = ({ onClose, currentSelectedBooking, vendorsList }) => {
  const dispatch = useDispatch();

  /* ---------------------------- LOCAL STATES ---------------------------- */
  const [isValidationShow, setIsValidationShow] = useState(false);

  const [selectedRemark, setSelectedRemark] = useState(null);

  const [modifiedVendorsData, setModifiedVendorsData] = useState([]);
  const [currentSelectedVendorsCar, setCurrentSelectedVendorsCar] = useState(null);

  /* ---------------------------- REDUX STATES ---------------------------- */
  const { assignVendor, assignVendorLoading, assignVendorRemarks, assignVendorRemarksLoading } = useSelector(state => ({
    assignVendor: state?.AssignVendor?.data,
    assignVendorLoading: state?.AssignVendor?.loading,

    assignVendorRemarks: state?.GetReasonByActions?.data,
    assignVendorRemarksLoading: state?.GetReasonByActions?.loading,
  }));

  useEffect(() => {
    if (assignVendor !== null) {
      dispatch({
        type: ASSIGN_VENDOR_EMPTY,
      });
      onClose();
    }

    return () => {
      dispatch({
        type: ASSIGN_VENDOR_EMPTY,
      });
    };
  }, [assignVendor]);

  useEffect(() => {
    if (vendorsList?.vendors?.length > 0) {
      const groupedVendors = groupVendorsByName(vendorsList?.vendors);
      setModifiedVendorsData(groupedVendors ?? []);

      const preferredVendorsList = vendorsList?.vendors?.filter(vendor => vendor?.isSystemPreffered === true);

      if (preferredVendorsList?.length === 1) {
        setCurrentSelectedVendorsCar(preferredVendorsList?.[0]);
      } else {
        setCurrentSelectedVendorsCar(null);
      }
    }
  }, [vendorsList]);

  const onSelectVendorCar = data => {
    setSelectedRemark(null);
    const selectedVendorCar = JSON.parse(data.target.value);
    setCurrentSelectedVendorsCar(selectedVendorCar);
  };

  useEffect(() => {
    dispatch({
      type: GET_REASON_BY_ACTIONS,
      payload: {
        urlParams: {
          booking_type: currentSelectedBooking?.bookingType || '',
          booking_status: currentSelectedBooking?.bookingStatus,
          action: 'change_vendor',
          is_active: true,
          page_size: 50,
          page_index: 0,
        },
      },
    });
  }, [currentSelectedBooking]);

  const assignVendorToTheBooking = () => {
    if (
      (currentSelectedVendorsCar?.isSystemPreffered === true && selectedRemark === null) ||
      (currentSelectedVendorsCar?.isSystemPreffered === false && selectedRemark !== null)
    ) {
      const payloadBody = {
        vendor_id: currentSelectedVendorsCar?.id,
        booking_id: currentSelectedBooking?.id,
        ...(selectedRemark === null ? {} : { reason_id: selectedRemark?.value }),
        vendor_name: currentSelectedVendorsCar?.name,
        vendor_price: `${currentSelectedVendorsCar?.price ?? ''}`,
        vendor_currency: `${currentSelectedVendorsCar?.currency ?? ''}`,
        vendor_zone: `${currentSelectedVendorsCar?.zone ?? ''}`,
        car_id: `${currentSelectedVendorsCar?.carId ?? ''}`,
      };

      dispatch({
        type: ASSIGN_VENDOR,
        payload: {
          body: {
            ...payloadBody,
          },
        },
      });
    } else {
      setIsValidationShow(true);
    }
  };

  console.log('modifiedVendorsData', modifiedVendorsData);

  return (
    <Modal isOpen={true} centered size="lg">
      <ModalHeader toggle={onClose}>
        <h4 className="assign-vendor-title">
          Assign to Vendor - <span className="vendor-booking-id"> Booking ID: {currentSelectedBooking?.bookingId}</span>
        </h4>
      </ModalHeader>

      <ModalBody className="vendor-selection-body">
        <div className="vendor-scroll-container">
          <div className="vendor-main-div">
            {Object.entries(modifiedVendorsData)?.map(([vendorName, vendorData]) => {
              const isActive = vendorData?.filter(vendor => vendor?.id === currentSelectedVendorsCar?.id)?.length > 0;

              return (
                <div className={`vendor-cars ${isActive ? 'active-vendor' : ''}`}>
                  <div className="vendor-name">{vendorName}</div>

                  {isActive && (
                    <div className="selected-vendor-container">
                      <img src={SelectedItem} className="selected-vendor" />
                    </div>
                  )}

                  <div className="tag-container">
                    <p className="tag-label">
                      {vendorName === currentSelectedVendorsCar?.name ? (
                        <>{currentSelectedVendorsCar?.tag || ''}</>
                      ) : (
                        <>{vendorData?.[0]?.tag || ''}</>
                      )}
                    </p>
                  </div>

                  <div className="vendor-core-details">
                    <div className="core-detail">
                      <img src={AvailabilityTick} className="availability-tick" />
                      <p>Distance - {`${vendorData?.[0]?.distance}`}</p>
                    </div>
                    <div className="core-detail">
                      <img src={AvailabilityTick} className="availability-tick" />
                      <p>Zone - {`${vendorData?.[0]?.zone}`}</p>
                    </div>
                  </div>

                  <div>
                    <Label htmlFor="car-type" className="form-label">
                      <span>Select Car Name</span>
                    </Label>

                    <select className="vendor-cars-dropdown" onChange={onSelectVendorCar} value={JSON.stringify(currentSelectedVendorsCar)}>
                      {!isActive && <option value={null}>--Select--</option>}

                      {vendorData?.map((vendorD, index) => (
                        <option value={JSON.stringify(vendorD)} key={index}>
                          {vendorD?.carName}
                        </option>
                      ))}
                    </select>
                  </div>

                  <h4 className="vendor-price">
                    {vendorName === currentSelectedVendorsCar?.name ? (
                      <>
                        {currentSelectedVendorsCar?.currency || ''} {currentSelectedVendorsCar?.price || ''}
                      </>
                    ) : (
                      <>
                        {vendorData?.[0]?.currency || ''} {vendorData?.[0]?.price || ''}
                      </>
                    )}
                  </h4>

                  {vendorName === currentSelectedVendorsCar?.name ? (
                    <Button className="cta-select-vendor" color="primary">
                      Selected
                    </Button>
                  ) : (
                    <Button className="cta-select-vendor active" color="primary">
                      Choose
                    </Button>
                  )}
                </div>
              );
            })}
          </div>
        </div>

        <Row className="mt-4">
          <Col md={8}>
            {currentSelectedVendorsCar !== null && !currentSelectedVendorsCar?.isSystemPreffered && (
              <div>
                <label>Remarks</label>
                <Select
                  options={assignVendorRemarks?.reasons?.map(remark => ({
                    label: `${remark?.reason}`,
                    value: `${remark?.id}`,
                  }))}
                  onChange={option => {
                    setSelectedRemark(option);
                    setIsValidationShow(false);
                  }}
                  value={selectedRemark}
                />
                {isValidationShow && selectedRemark === null && <Error text="Please select reason" />}
              </div>
            )}
          </Col>

          <Col md={4} className="text-end" style={{ alignSelf: 'end' }}>
            {!assignVendorLoading && (
              <Button
                color="primary"
                onClick={assignVendorToTheBooking}
                disabled={currentSelectedVendorsCar?.isSystemPreffered === false && selectedRemark === null}
                style={{ width: '150px' }}
              >
                Assign to Vendor
              </Button>
            )}

            {assignVendorLoading && (
              <Button color="primary" style={{ width: '150px' }}>
                <Spinner className="btn-replacer-spinner" />
              </Button>
            )}
          </Col>
        </Row>
      </ModalBody>
    </Modal>
  );
};

export default AssignVendor;

function groupVendorsByName(vendors) {
  const groupedVendors = {};

  vendors.forEach(vendor => {
    const name = vendor.name.trim();
    if (!groupedVendors[name]) {
      groupedVendors[name] = [];
    }
    groupedVendors[name].push(vendor);
  });

  for (const name in groupedVendors) {
    groupedVendors[name].sort((a, b) => {
      return (b.isSystemPreffered === true ? 1 : 0) - (a.isSystemPreffered === true ? 1 : 0);
    });
  }

  return groupedVendors;
}
